// extracted by mini-css-extract-plugin
export var noSpinners = "_so-6";
export var percentageInput = "_so-7";
export var variantColor1 = "_so-0";
export var variantColor2 = "_so-1";
export var variantColor3 = "_so-2";
export var variantColor4 = "_so-3";
export var variantColor5 = "_so-4";
export var variantColor6 = "_so-5";